import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class IntranetSearchService {
  private intranetsURL = 'intranets';

  constructor(private httpClient: HttpClientService) {}

  getIntranetInfo(id: number): Promise<any> {
    return this.httpClient.get(`${this.intranetsURL}/${id}.json`, {
      get_info: true,
    });
  }
}
